import React from 'react'
import { Sparkles } from 'lucide-react'
import MarkdownEditor from './MarkdownEditor'
import clsx from 'clsx'

type LookAndFeelData = {
    id: string
    description: string
    images?: string[]
}

type Props = {
    lookAndFeel: LookAndFeelData
    onChange: (value: LookAndFeelData) => void
    disabled?: boolean
    className?: string
}

const LookAndFeelSection: React.FC<Props> = ({
    lookAndFeel,
    onChange,
    disabled = false,
    className = '',
}) => {

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (!file) return

        const reader = new FileReader()
        reader.onload = () => {
            const imageUrl = reader.result as string
            onChange({
                ...lookAndFeel,
                images: [...(lookAndFeel.images || []), imageUrl]
            })
        }
        reader.readAsDataURL(file)
    }

    const handleRemoveImage = (index: number) => {
        onChange({
            ...lookAndFeel,
            images: (lookAndFeel.images || []).filter((_, i) => i !== index)
        })
    }

    return (
        <section className={clsx('card p-4 md:p-6 flex flex-col gap-4', className)}>
            <div className="flex items-center gap-2 mb-2">
                <Sparkles className="w-5 h-5 text-brixel" />
                <span className="font-semibold text-gray-900">Look &amp; Feel</span>
            </div>
            <MarkdownEditor
                value={lookAndFeel.description}
                onChange={(val) => onChange({ ...lookAndFeel, description: val })}
                placeholder="Décrivez ici l’identite visuelle: palette, ambiance, polices, style d’illustrations, direction artistique, UX, ton général… (Markdown possible)"
                minRows={4}
                maxRows={16}
                disabled={disabled}
            />
            <div className="mt-4">
                <label className="text-sm font-medium text-gray-700">Images</label>
                <div className="flex flex-wrap gap-2 mt-2">
                    {(lookAndFeel.images || []).map((url, index) => (
                        <div key={index} className="relative group">
                            <img
                                src={url}
                                alt={`img-${index}`}
                                className="w-24 h-24 object-cover rounded border border-gray-200"
                            />
                            <button
                                type="button"
                                title="Supprimer"
                                onClick={() => handleRemoveImage(index)}
                                className="absolute top-1 right-1 bg-white/80 rounded-full p-1 shadow hover:bg-red-500 hover:text-white transition text-sm text-gray-600"
                            >
                                ×
                            </button>
                        </div>
                    ))}
                    <label className="w-24 h-24 flex items-center justify-center border border-dashed border-gray-300 rounded cursor-pointer hover:bg-gray-100 text-sm text-gray-500">
                        +
                        <input
                            type="file"
                            accept="image/*"
                            hidden
                            onChange={handleImageUpload}
                        />
                    </label>
                </div>
            </div>
        </section>
    )
}

export default LookAndFeelSection
